import React from "react";
import Select from "react-select/lib/Select";
import { TASK_PRIVACY_TYPES } from "./data";

export default function PrivacyStatusComponent({ item, onDataChange, index }) {
  const handleOnChange = val => {
    onDataChange(index, val.value, "privacyStatus");
  };
  return (
    <div style={{ flexGrow: 1 }}>
      <Select
        options={TASK_PRIVACY_TYPES}
        onChange={handleOnChange}
        value={item.privacyStatus}
      />
    </div>
  );
}
